import { useQuery } from 'react-query';

import { getFeromonTraps } from 'api/traps/FeromonTraps/getFeromonTraps';
import { TrapTableType } from 'components/TrapsTables/trapTables';

export const useGetFeromonTraps = (slug: string, page: number, search?: string, ordering?: string) => {
  const { data, refetch, isLoading } = useQuery(
    TrapTableType.FeromonTraps,
    () => getFeromonTraps(slug, page, search, ordering),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading };
};

export default useGetFeromonTraps;
